import axios from '@/utils/request'

export default {
  // getCertificationList: params => axios({ url: `/api/store/certificationList`, method: 'GET',params }),// 后台-客户管理列表查询
  getCustomerList: data => axios({ url: `/api/store/customerList`, method: 'POST',data }),// 后台-客户管理列表查询
  getUserCertification: userId => axios({ url: `/api/store/certification/${userId}`, method: 'GET' }),// 获取认证审核信息
  getUserDetail: userId => axios({ url: `/api/store/user/${userId}`, method: 'GET' }),// 根据用户id获取用户信息
  getStoreList: userId => axios({ url: `/api/store/customStoreList/${userId}`, method: 'GET' }),// 店铺列表
  getStoreSetting: storeId => axios({ url: `/api/store/storeSettingDetail/${storeId}`, method: 'GET' }),// 店铺设置信息
  getBalance: userId => axios({ url: `/api/payment/balance/${userId}`, method: 'GET' }),// 获取用户信息
  getLoginLogs: userId => axios({ url: `/api/store/loginLogs/${userId}`, method: 'GET' }),// 根据用户ID获取登录日志
  addCertification: data => axios({ url: `/api/store/certification`, method: 'POST',data }),// 新增或编辑客户认证资料
  getAllUpcomingMatter: () => axios({ url: `/api/report/allUpcomingMatter`, method: 'GET' }),// 后台-仪表盘获取待办事项
  certificationAuditCustomer: data => axios({ url: `/api/store/certificationAuditCustomer`, method: 'POST',data }),// 后台-认证审核认证资料
}